import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { RootState } from '../../../stateManagement/store'
import { getItemWebStorage } from '../../../features/webStorageSaver/webStorageSaver'

const baseQuery = fetchBaseQuery({
    baseUrl: `/`,
    prepareHeaders: (headers, { getState }) => {
        let token = (getState() as RootState).auth.tokens.app
        if (token) {
            headers.set('Authorization', `Bearer ${token}`)
        }
        return headers
    },
})

const dynamicBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const urlEnd = typeof args === 'string' ? args : args.url
    // construct a dynamically generated portion of the url
    const geocoderApiUrlLocal = getItemWebStorage("geocoderApiUrl")
    const adjustedUrl = `${geocoderApiUrlLocal}/${urlEnd}`
    const adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, currentApiUrl: geocoderApiUrlLocal, url: adjustedUrl }
    // provide the amended url and other params to the raw base query
    return baseQuery(adjustedArgs, api, extraOptions)
}

export const geocoderAPI = createApi({
    reducerPath: 'geocoderAPI',
    baseQuery: dynamicBaseQuery,
    endpoints: builder => ({})
})

export const geocoderAPIReducer = geocoderAPI.reducer
export const resetGeocoderAPI = geocoderAPI.util.resetApiState